import { FilterOption, FRSFilterOptionsModel } from './filter-options-types';

export const FRSFilterOptions = (periodNames: string[], regions : string[]): FilterOption[] => {
    
  return [
          {
            id: 'region',
            title: 'Region',
            required: true,
            disabled: false,
            hidden: false,
            isMultiple: true,
            optionList: regions,
            onChangeUpdate:[FRSFilterOptionsModel.Countries],
            selected: [],
            level: 0, // Hide all levels > 0 if not selected
          },
          {
            id: 'countries',
            title: 'Countries',
            required: true,
            disabled: false,
            hidden: true,
            isMultiple: true,
            optionList: [],
            onChangeUpdate:[FRSFilterOptionsModel.TopLevelCustomerName, FRSFilterOptionsModel.SecondLevelContractFilter],
            selected: [],
            level: 1, // Hide all levels > 1 if not selected
            isLoading: false,
          },
          {
            id: 'topLevelCustomerName',
            title: 'Top Level Hierarchy (H5)',
            required: false,
            hidden: true,
            disabled: false,
            isMultiple: true,
            optionList: [],
            onChangeUpdate:[FRSFilterOptionsModel.SecondLevelContractFilter,FRSFilterOptionsModel.CustomerNumberName],
            selected: [],
            level: 2, // Hide all levels > 2 if not selected
            isLoading: false,
            isSelectedFilter: true // This is used when we apply the saved filters need to show the selected filters
          },
          {
            id: 'SecondLevelContractFilter',
            title: 'Agreement (H7)',
            required: false,
            disabled: false,
            hidden: true,
            isMultiple: true,
            optionList: [],
            onChangeUpdate:[FRSFilterOptionsModel.CustomerNumberName],
            selected: [],
            level: 2, // Hide all levels > 3 if not selected
            isLoading: false,
            isSelectedFilter: true // This is used when we apply the saved filters need to show the selected filters 
          },
          {
            id: 'dateRange',
            title: 'Date Range',
            required: true,
            disabled: false,
            hidden: true,
            isMultiple: false,
            optionList: periodNames,
            onChangeUpdate:[],
            selected: [],
            level: 3,
            isLoading: false

          },
          {
            id: 'customerNumberName',
            title: 'Customer Number / Name',
            required: false,
            disabled: false,
            hidden: true,
            isMultiple: true,
            optionList: [],
            onChangeUpdate:[],
            selected: [],
            level: 3, 
            isLoading: false,
            isSelectedFilter: true // This is used when we apply the saved filters need to show the selected filters
          }
          
    ]
}